import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import userSlice from './userSlice';
import breakSlice from './breakSlice';
import buoySlice from './buoySlice';
import entrySlice from './entrySlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

const userPersistConfig = {
    key: 'user',
    storage: storage,
    whitelist: ["user", "token", "signedIn"]
}

export const rootReducer = combineReducers({
    user: persistReducer(userPersistConfig, userSlice),
    breaks: breakSlice,
    buoys: buoySlice,
    entries: entrySlice
}) 

export const store = configureStore({
    reducer: rootReducer,
    middleware: () => getDefaultMiddleware({serializableCheck: false})    
})
export const persistor = persistStore(store)